import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  TimeTableSave: null,
  user: null,
  Answers: {},
  year_id: null,
  listyear: null,
  notification: {},
  bookingstatus: {},
  carBookingStatus: {},
  countcv: {},
  datasocket: null,
  saveRealTimeData: null,
};
export const slice = createSlice({
  name: "save",
  initialState: initialState,
  reducers: {
    choice: (state, action) => {
      if (action.payload.hasOwnProperty("TimeTableSave"))
        state.TimeTableSave = action.payload.TimeTableSave;
      if (action.payload.hasOwnProperty("user"))
        state.user = action.payload.user;
      if (action.payload.hasOwnProperty("Answers"))
        state.Answers = action.payload.Answers;
      if (action.payload.hasOwnProperty("year_id"))
        state.year_id = action.payload.year_id;
      if (action.payload.hasOwnProperty("listyear"))
        state.listyear = action.payload.listyear;
      if (action.payload.hasOwnProperty("notification"))
        state.notification = action.payload.notification;
      if (action.payload.hasOwnProperty("bookingstatus"))
        state.bookingstatus = action.payload.bookingstatus;
      if (action.payload.hasOwnProperty("carBookingStatus"))
        state.carBookingStatus = action.payload.carBookingStatus;
      if (action.payload.hasOwnProperty("countcv"))
        state.countcv = action.payload.countcv;
      if (action.payload.hasOwnProperty("datasocket"))
        state.datasocket = action.payload.datasocket;
      if (action.payload.hasOwnProperty("getpost"))
        state.getpost = action.payload.getpost;
      if (action.payload.hasOwnProperty("savecomment"))
        state.savecomment = action.payload.savecomment;
      if (action.payload.hasOwnProperty("saveLike"))
        state.saveLike = action.payload.saveLike;
      if (action.payload.hasOwnProperty("savePosts"))
        state.savePosts = action.payload.savePosts;
      if (action.payload.hasOwnProperty("saveWorkfollow"))
        state.saveWorkfollow = action.payload.saveWorkfollow;
      if (action.payload.hasOwnProperty("saveReloadBCC"))
        state.saveReloadBCC = action.payload.saveReloadBCC;
      if (action.payload.hasOwnProperty("saveRealTimeData"))
        state.saveRealTimeData = action.payload.saveRealTimeData;
    },
  },
});
